import { Card, CardCategories } from "@types"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface OrangePricingCardProps {
  cards: Card
  isSelectedCard?: boolean
  setSelectedCard?: Dispatch<SetStateAction<Card | undefined>>
  setShowQuote?: Dispatch<SetStateAction<boolean>>
}
export const OrangePricingCardProps = ({
  cards,
  isSelectedCard,
  setSelectedCard,
  setShowQuote,
}: OrangePricingCardProps) => {
  const [checkedItems, setCheckedItems] = React.useState(
    (cards.categories as CardCategories[]).map((category) =>
      (category?.list ?? []).map((item) => ({ ...item, isChecked: false }))
    )
  )

  const toggleCheckbox = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]
    updatedCheckedItems[categoryIndex][listIndex].isChecked =
      !updatedCheckedItems[categoryIndex][listIndex].isChecked
    setCheckedItems(updatedCheckedItems)
  }
  const toggleRadioOption = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Uncheck all items in the category
    updatedCheckedItems[categoryIndex] = updatedCheckedItems[categoryIndex].map(
      (item, i) => ({
        ...item,
        isChecked: i === listIndex, // Only the selected item is checked
      })
    )

    setCheckedItems(updatedCheckedItems)
  }
  const getSelectedCard = () => {
    const selectedCard = {
      ...cards,
      categories:
        cards.categories &&
        cards.categories.map((category, categoryIndex) => ({
          ...category,
          list:
            category.list &&
            category.list.map((item, listIndex) => ({
              ...item,
              isChecked: checkedItems[categoryIndex][listIndex].isChecked,
            })),
        })),
    }
    if (setSelectedCard) setSelectedCard(selectedCard)
  }
  return (
    <>
      <div className="bg-orange-card bg-input pt-2 pb-4 shadow-lg rounded-lg col-span-6">
        <div className="flex rounded-2xl mx-auto bg-btn px-2 max-w-[60%] w-fit">
          <div className="text-center w-full rounded-lg">
            <p className="text-dark-orange font-semibold text-nowrap text-xl p-2">
              {cards.cardTitle}
            </p>
          </div>
        </div>
        <div className="pt-8 px-10">
          <div className="px-2">
            <h3 className="text-6xl font-semibold text-dark-orange text-center">
              {cards.cardPrice}
            </h3>
            <p className="text-black text-center text-2xl text-nowrap font-semibold pt-4">
              {cards.subtitle?.split(" ").slice(0, -2).join(" ")}{" "}
              <span className="text-dark-orange font-semibold">
                {cards.subtitle?.split(" ").slice(-2).join(" ")}
              </span>
            </p>
            <p className="text-dark-orange font-semibold text-center pt-3">
              {cards.description}
            </p>
          </div>
          <div className="flex justify-center">
            <hr className="w-4/6 opacity-30" />
          </div>

          {cards?.categories &&
            cards?.categories.map((category: CardCategories, index) => (
              <>
                <div className="relative w-fit mx-auto">
                  <div className="h-2"></div>
                  <p
                    className={`text-black text-center text-lg font-semibold ${
                      category.titleColor === "cardColor"
                        ? "text-dark-orange"
                        : "text-black"
                    }`}
                  >
                    {category.title}{" "}
                    {category.alignment === "right" && (
                      <span className="text-xs text-dark-orange">
                        {category.titleSubDescription}
                      </span>
                    )}
                  </p>
                  <div className="text-center pb-3 text-lg font-semibold">
                    <p className="text-xs text-black">
                      {category.titleSubDescription}
                    </p>
                  </div>
                </div>
                {category.list &&
                  category.type === "tick" &&
                  category?.list.map((list) => (
                    <div className="text-black flex gap-2 items-center text-xs font-normal pt-2">
                      <div className="stroke">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="8"
                          viewBox="0 0 10 8"
                          fill="none"
                        >
                          <path
                            d="M1 4.2L3.66667 7L9 1"
                            stroke=""
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <p className="text-gray font-semibold">
                        {list.title}{" "}
                        <span className="text-[10px] text-dark-orange">
                          {list.titleSubDescription}
                        </span>
                      </p>
                    </div>
                  ))}
                {category.list && category.type === "selectionOptions" && (
                  <div className="text-black grid-container px-16 pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" col-span-8 my-1 gap-2 flex items-center"
                          >
                            <div
                              onClick={() => toggleCheckbox(index, i)}
                              className="checkbox cursor-pointer border border-black w-6 h-6"
                            >
                              {(checkedItems[index][i].isChecked ||
                                list.isChecked) && (
                                <div className="checked bg-[#7B68EC] w-full text-center text-white">
                                  ✓
                                </div>
                              )}
                            </div>
                            <p className="text-black text-xs">{list.title}</p>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-8 my-1 gap-2 flex items-center"
                              >
                                <div
                                  onClick={() => toggleCheckbox(index, i)}
                                  className="checkbox cursor-pointer border border-black w-6 h-6"
                                >
                                  {(checkedItems[index][i].isChecked ||
                                    list.isChecked) && (
                                    <div className="checked bg-[#7B68EC] w-full text-center text-white">
                                      ✓
                                    </div>
                                  )}
                                </div>
                                <p className="text-black text-xs">
                                  {list.title}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {category.list && category.type === "radioOptions" && (
                  <div className="text-white grid-container pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" col-span-5 my-1 gap-2 flex items-center"
                          >
                            <div className="flex gap-2 items-center">
                              <div className="border border-black rounded-full flex items-center justify-center p-1 w-6 h-6">
                                <input
                                  className="input-radio !w-3 !h-3"
                                  type="radio"
                                  id={list.title}
                                  value={list.title}
                                  name="orangeCard"
                                  checked={list.isChecked}
                                  onChange={() => toggleRadioOption(index, i)}
                                />
                              </div>
                              <label
                                className="text-black text-xs"
                                htmlFor={list.title}
                              >
                                {list.title}
                              </label>
                            </div>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-5 my-1 gap-2 flex items-center"
                              >
                                <div className="flex gap-2 items-center">
                                  <div className="border border-black rounded-full flex items-center justify-center p-1 w-6 h-6">
                                    <input
                                      className="input-radio !w-3 !h-3"
                                      type="radio"
                                      id={list.title}
                                      value={list.title}
                                      name="orangeCard"
                                      checked={list.isChecked}
                                      onChange={() =>
                                        toggleRadioOption(index, i)
                                      }
                                    />
                                  </div>
                                  <label
                                    className="text-black text-xs"
                                    htmlFor={list.title}
                                  >
                                    {list.title}
                                  </label>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
              </>
            ))}
          <div>
            <p className="text-black text-xs text-center pt-8">
              {cards.footerDescription}{" "}
              <span className="text-dark-orange">
                {cards.footerSubDescription}
              </span>
            </p>
          </div>
          <div className="pt-4">
            {isSelectedCard !== true && (
              <button
                onClick={() => {
                  getSelectedCard()
                  setShowQuote && setShowQuote(true)
                }}
                className="card-btn-border border-black bg-btn text-sm py-3 text-black w-full p-2 rounded-3xl"
              >
                Download Quote
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
